import React from 'react';
import PropTypes from 'prop-types';

import { TextField } from 'material-ui-formik-components/TextField';
import ClearIcon from '@material-ui/icons/Clear';
import { Field } from 'formik';

import { withStyles } from '@material-ui/core/styles';
import styles from './styles.js';

function FormikTextField(props) {
  const { classes, name, value, label, maxLength, clear } = props;

  return (
    <div className={classes.root}>
      <Field
        name={name}
        component={TextField}
        value={value}
        label={label}
        variant='outlined'
        multiline
        rows='4'
        id={name}
        inputProps={{
          maxLength: maxLength,
        }}
        InputProps={{
          className: classes.input,
        }}
        InputLabelProps={{
          classes: {
            root: classes.label,
            shrink: 'shrink',
          },
          htmlFor: name,
        }}
      />
      {value && clear && (
        <ClearIcon className={classes.clear} onClick={clear} />
      )}
    </div>
  );
}

FormikTextField.propTypes = {
  classes: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  label: PropTypes.string.isRequired,
  maxLength: PropTypes.number,
  clear: PropTypes.func,
};

FormikTextField.defaultProps = {
  maxLength: 250,
};

export default withStyles(styles)(FormikTextField);
